module.exports = __webpack_public_path__ + "img/overhoren.aacd5dc6.png";